export const FETCH_SONG_REQUEST = "FETCH_SONG_REQUEST";
export const FETCH_SONG_ERROR = "FETCH_SONG_ERROR";
export const FETCH_SONG_RESET = "FETCH_SONG_RESET";

export const FETCH_ALL_SONGS_SUCCESS = "FETCH_ALL_SONGS_SUCCESS";
export const FETCH_MY_SONGS_SUCCESS = "FETCH_MY_SONGS_SUCCESS";
export const FETCH_POPULAR_SONGS_SUCCESS = "FETCH_POPULAR_SONGS_SUCCESS";
export const FETCH_FAVORITE_SONGS_SUCCESS = "FETCH_FAVORITE_SONGS_SUCCESS";

export const FETCH_SONG_BY_ID_REQUEST = "FETCH_SONG_BY_ID_REQUEST";
export const FETCH_SONG_BY_ID_SUCCESS = "FETCH_SONG_BY_ID_SUCCESS";
export const FETCH_SONG_BY_ID_ERROR = "FETCH_SONG_BY_ID_ERROR";
export const FETCH_SONG_BY_ID_RESET = "FETCH_SONG_BY_ID_RESET";

export const LIKE_SONG_REQUEST = "LIKE_SONG_REQUEST";
export const LIKE_SONG_SUCCESS = "LIKE_SONG_SUCCESS";
export const LIKE_SONG_ERROR = "LIKE_SONG_ERROR";

export const RESET_STATE = "RESET_STATE";

export const DELETE_SONG_REQUEST = "DELETE_SONG_REQUEST";
export const DELETE_SONG_SUCCESS = "DELETE_SONG_SUCCESS";
export const DELETE_SONG_ERROR = "DELETE_SONG_ERROR";
export const DELETE_SONG_RESET = "DELETE_SONG_RESET";

export const UPDATE_SONG_REQUEST = "UPDATE_SONG_REQUEST";
export const UPDATE_SONG_SUCCESS = "UPDATE_SONG_SUCCESS";
export const UPDATE_SONG_ERROR = "UPDATE_SONG_ERROR";
export const UPDATE_SONG_RESET = "UPDATE_SONG_RESET";
export const UPDATE_UPDATED_SONG = "UPDATE_UPDATED_SONG";

export const ADD_UPLOADED_SONG = "ADD_UPLOADED_SONG";

export const SONG_TO_UPDATE = "SONG_TO_UPDATE";
export const SONG_TO_DELETE = "SONG_TO_DELETE";

export const DELETE_PLAYBACK_REQUEST = "DELETE_PLAYBACK_REQUEST";
export const DELETE_PLAYBACK_SUCCESS = "DELETE_PLAYBACK_SUCCESS";
export const DELETE_PLAYBACK_ERROR = "DELETE_PLAYBACK_ERROR";

export const DELETE_PLAYBACK_MONTHLY_REQUEST =
  "DELETE_PLAYBACK_MONTHLY_REQUEST";
export const DELETE_PLAYBACK_MONTHLY_SUCCESS =
  "DELETE_PLAYBACK_MONTHLY_SUCCESS";
export const DELETE_PLAYBACK_MONTHLY_ERROR = "DELETE_PLAYBACK_MONTHLY_ERROR";

export const songsTypes = {
  ALL_SONGS: "ALL_SONGS",
  MY_SONGS: "MY_SONGS",
  FAVORITE: "FAVORITE",
  POPULAR: "POPULAR",
  RECOMMENDED: "RECOMMENDED",
  LISTENED_RECENTLY: "LISTENED_RECENTLY",
  BASED_ON_LISTENED: "BASED_ON_LISTENED",
};
